import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setLanguage, toggleLanguage } from '../../redux/actions'
import { RootState } from '../../redux/store'
import { Lang, submissionTranslations } from './translations'

const FONTS: Record<Lang, string> = {
  TH: "'Noto Sans Thai', sans-serif",
  EN: "'Poppins', sans-serif",
}

export function useLang() {
  const lang = useSelector((state: RootState) => state.language) as Lang
  const dispatch = useDispatch()
  const toggle = () => dispatch(toggleLanguage())
  const setLang = (newLang: Lang) => dispatch(setLanguage(newLang))
  const tr = submissionTranslations[lang]

  useEffect(() => {
    document.body.style.fontFamily = FONTS[lang]
  }, [lang])

  return { lang, tr, toggle, setLang }
}
